import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectShipment } from "../../shipmentSlice";
import {
    createShipmentBox,
    selectCreatingBoxStatus,
    setCreatingShipmentBoxStatus,
} from "../shipmentItemsSlice";

import style from "../../../../sass/pages/shipment/shipment.module.scss";
import { validators } from "../../../../validators/validators";
import GreenSpinner from "../../../../components/loaders/GreenSpinner";
import { useTranslation } from "react-i18next";

const CreateNewBoxButton = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const shipment = useSelector(selectShipment);
    const creatingBoxStatus = useSelector(selectCreatingBoxStatus);

    const [isCreatingMode, setIsCreatingMode] = useState(false);
    const [isPending, setIsPending] = useState(false);
    const [sizesState, setSizesState] = useState({
        length: "",
        width: "",
        height: "",
        weight: "",
    });

    const setLength = (value) => {
        if (!value) {
            setSizesState((prev) => ({
                ...prev,
                length: "",
            }));
        }
        let err = validators.ValidateNumber(value);
        if (err !== null) {
            return;
        }
        setSizesState((prev) => ({
            ...prev,
            length: value,
        }));
    };
    const setWidth = (value) => {
        if (!value) {
            setSizesState((prev) => ({
                ...prev,
                width: "",
            }));
        }
        let err = validators.ValidateNumber(value);
        if (err !== null) {
            return;
        }
        setSizesState((prev) => ({
            ...prev,
            width: value,
        }));
    };
    const setHeight = (value) => {
        if (!value) {
            setSizesState((prev) => ({
                ...prev,
                height: "",
            }));
        }
        let err = validators.ValidateNumber(value);
        if (err !== null) {
            return;
        }
        setSizesState((prev) => ({
            ...prev,
            height: value,
        }));
    };
    const setWeight = (value) => {
        if (!value) {
            setSizesState((prev) => ({
                ...prev,
                weight: "",
            }));
        }
        let err = validators.ValidateNumber(value);
        if (err !== null) {
            return;
        }
        setSizesState((prev) => ({
            ...prev,
            weight: value,
        }));
    };
    const handleButtonClick = () => {
        setIsCreatingMode(!isCreatingMode);
    };
    const handleCreateShipmentBoxClick = () => {
        let heightErr = validators.ValidateNumber(sizesState.height);
        let widthErr = validators.ValidateNumber(sizesState.width);
        let lengthErr = validators.ValidateNumber(sizesState.length);

        if (heightErr || widthErr || lengthErr) return;

        dispatch(setCreatingShipmentBoxStatus({ status: null }));
        dispatch(
            createShipmentBox({
                shipmentID: shipment.id,
                sizes: {
                    length: +sizesState.length,
                    width: +sizesState.width,
                    height: +sizesState.height,
                    weight: +sizesState.weight,
                },
            })
        );
    };

    useEffect(() => {
        if (creatingBoxStatus === "pending") {
            setIsPending(true);
            return;
        }

        if (
            creatingBoxStatus === "fulfilled" ||
            creatingBoxStatus === "rejected"
        ) {
            setIsCreatingMode(false);
            setIsPending(false);
        }
    }, [creatingBoxStatus]);

    console.log(isCreatingMode);

    return (
        <div className="text-left">
            {isCreatingMode && (
                <div className="flex gap-x-1 gap-y-2 flex-wrap items-center mb-4">
                    <input
                        className={`${style.input} text-2xs`}
                        type="text"
                        placeholder={t("shipment.items.create_box.height")}
                        style={{ width: 80 }}
                        value={sizesState.height}
                        onInput={(e) => setHeight(e.target.value)}
                    />
                    <span className="font-medium">*</span>
                    <input
                        className={`${style.input} text-2xs`}
                        type="text"
                        placeholder={t("shipment.items.create_box.width")}
                        style={{ width: 80 }}
                        value={sizesState.width}
                        onInput={(e) => setWidth(e.target.value)}
                    />
                    <span className="font-medium">*</span>
                    <input
                        className={`${style.input} text-2xs`}
                        type="text"
                        placeholder={t("shipment.items.create_box.length")}
                        style={{ width: 80 }}
                        value={sizesState.length}
                        onInput={(e) => setLength(e.target.value)}
                    />
                    <input
                        className={`${style.input} text-2xs`}
                        type="text"
                        placeholder={t("shipment.items.create_box.weight")}
                        style={{ width: 80 }}
                        value={sizesState.weight}
                        onInput={(e) => setWeight(e.target.value)}
                    />
                    <div>
                        {isPending ? (
                            <GreenSpinner />
                        ) : (
                            <div
                                className={`${style.btn} ${style["btn-primary"]} p-2 text-xs`}
                                onClick={handleCreateShipmentBoxClick}
                            >
                                {t("shipment.items.create_box.save_button")}
                            </div>
                        )}
                    </div>
                </div>
            )}

            <Button
                variant="contained"
                sx={{
                    color: "white",
                    bgcolor: "#059669",
                    fontSize: "0.8rem",
                    ":hover": {
                        bgcolor: "#047857",
                    },
                    ":focus": {
                        bgcolor: "#047857",
                    },
                }}
                onClick={handleButtonClick}
            >
                {isCreatingMode ? 
                    t("shipment.items.create_box.close_button") : 
                    t("shipment.items.create_box.title")}
            </Button>
        </div>
    );
};

export default CreateNewBoxButton;
